import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function showAllDiscountCodeToggled(
  state: WritableDraft<QuoteBuilderStateType>,
) {
  state.showAllDiscountCodes = !state.showAllDiscountCodes;
}
